import { DeviceDataType } from '../DeviceConfig/device-types'

/**
 * Resolves the device VPN IP used to reach its VNC stream.
 * Terminals/screens keep it under `system.wireguard`; scanners use `networking.wireguard`.
 * Per-device values live in `config.diff`, defaults in `config.base`.
 */
export const getVncHostIp = (device: DeviceDataType | undefined): string | null => {
    const ip =
        device?.config?.diff?.system?.wireguard?.interface?.ip ??
        device?.config?.base?.system?.wireguard?.interface?.ip ??
        device?.config?.diff?.networking?.wireguard?.interface?.ip ??
        device?.config?.base?.networking?.wireguard?.interface?.ip

    return typeof ip === 'string' && ip ? ip : null
}
